import React from "react";
import { Tabs } from "antd";
import PondList from "../../components/setting-conponents/PondTank/PondList";
import TankList from "../../components/setting-conponents/PondTank/TankList";
import PondSkimList from "../../components/setting-conponents/PondTank/PondSkimList";

export default function PondTankSettingView() {
  const [activeTab, setActiveTab] = React.useState("pond");

  const tableRef = React.useRef(null);

  const items = [
    {
      key: "pond",
      label: "บ่อพักน้ำยางสด",
      children: <PondList isDone={false} ref={tableRef} />,
    },
    {
      key: "tank",
      label: "แทงก์น้ำยางข้น",
      children: <TankList isDone={false} ref={tableRef} />,
    },
    // {
    //   key: "pond_skim",
    //   label: "บ่อสกิม",
    //   children: <PondSkimList isDone={false} ref={tableRef} />,
    // },
  ];

  return (
    <div style={{ marginTop: 20 }}>
      <Tabs
        destroyInactiveTabPane
        defaultActiveKey="pond"
        activeKey={activeTab}
        onChange={setActiveTab}
        items={items}
        style={{ marginTop: 15 }}
      />
    </div>
  );
}
